var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.resolvedUser)?_c('span',[(_vm.online !== null)?_c('span',{class:[_vm.online ? 'online-dot' : 'offline-dot']}):_vm._e(),_vm._v(" "+_vm._s(_vm.displayFullName ? _vm.fullName : _vm.resolvedUser.username))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }